import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationDataModel } from '@models/notification-data.model';
import { NotificationType } from '@models/notification-type.model';

const NOTIFICATION_TYPE_ICON_MAP: Record<NotificationType, string> = {
  [NotificationType.INFO]: 'info',
  [NotificationType.SUCCESS]: 'check_circle',
  [NotificationType.WARNING]: 'warning',
  [NotificationType.ERROR]: 'error',
};

const NOTIFICATION_ACTION_COLOR_MAP: Record<NotificationType, string> = {
  [NotificationType.INFO]: 'primary',
  [NotificationType.SUCCESS]: 'green',
  [NotificationType.WARNING]: 'yellow',
  [NotificationType.ERROR]: 'error',
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-basic-snackbar',
  imports: [MatSnackBarModule, MatButtonModule, MatIconModule],
  templateUrl: './basic-snackbar.html',
  styleUrl: './basic-snackbar.css',
})
export class BasicSnackbar {
  readonly snackBarRef = inject(MatSnackBarRef<BasicSnackbar>);
  readonly data = inject(MAT_SNACK_BAR_DATA) as NotificationDataModel;
  readonly icon = NOTIFICATION_TYPE_ICON_MAP[this.data.type];
  readonly actionColor = NOTIFICATION_ACTION_COLOR_MAP[this.data.type];
}
